/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { Shimmer } from '@fluentui/react/lib/Shimmer';
import { Stack } from '@fluentui/react/lib/Stack';
import React from 'react';
import { QnaMakerContextTreeNode } from 'src/qnaMaker/core/types/QnaMakerContextTreeNode';
import { QnaMakerContextLabel } from 'src/qnaMaker/verticals/qnaMakerQnaContextualTree/components/QnaMakerContextLabel';
import { QnaMakerQnaContextualTree } from 'src/qnaMaker/verticals/qnaMakerQnaContextualTree/QnaMakerQnaContextualTree';

export type QnaMakerContextColumnRendererProps = {
    qnaId: number;
    contextTrees: QnaMakerContextTreeNode[];
    isContextOnly: boolean;
    isContextTreeCalculating: boolean;
    onClickQna: (id: number) => void;
};

export const QnaMakerContextColumnRenderer = (props: QnaMakerContextColumnRendererProps) => {
    const { qnaId, contextTrees, isContextOnly, isContextTreeCalculating, onClickQna } = props;

    return (
        <Stack style={{ position: 'relative', width: '100%' }} verticalFill data-selection-disabled>
            {isContextTreeCalculating ? (
                <Stack tokens={{ childrenGap: 6 }}>
                    <Shimmer width="25%" />
                    <Shimmer width="75%" />
                    <Shimmer width="50%" />
                </Stack>
            ) : (
                <>
                    {isContextOnly && <QnaMakerContextLabel />}
                    <Stack tokens={{ childrenGap: 16 }}>
                        {contextTrees.map(contextTree => (
                            <QnaMakerQnaContextualTree
                                key={contextTree.id}
                                qnaId={qnaId}
                                contextTree={contextTree}
                                onClickQna={onClickQna}
                            />
                        ))}
                    </Stack>
                </>
            )}
        </Stack>
    );
};
